import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Sector, Legend } from 'recharts';
import { useColors } from '../../../colors/controller/Colors';
// 中間總數量呈現待解決
// 請建立顏色組合陣列 一組20個 
const COLORS = ['#55efc4', '#00b894', '#81ecec', '#00cec9', '#74b9ff', '#0984e3', '#a29bfe', '#6c5ce7', '#ffeaa7', '#fdcb6e', '#b2bec3', '#636e72', '#636e72', '#ff7675'];


const DonutChart = ({
    data = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 },
        { name: 'Group C', value: 300 },
        { name: 'Group D', value: 200 },
        { name: 'Group E', value: 200 },
        { name: 'Group F', value: 200 },
    ],
    dataKey = "value",
    showLegend = true,
    fontSize = '14px',
    colorTheams = "morandi"

}) => {
    const [colors, setColors] = useState([])
    const [activeKey, setactiveKey] = useState(null)
    const onPieEnter = (_, index) => {
        setactiveKey(index)
    };
    const onPieLeave = (_, index) => {
        setactiveKey(null)
    };
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, value }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.1;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="white"
                textAnchor={x > cx ? 'start' : 'end'}
                dominantBaseline="central"
                style={{
                    fontSize: fontSize
                }}
            >
                {`${value}`}
            </text>
        );
    };
    const renderActiveShape = (props) => {
        const RADIAN = Math.PI / 180;
        const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);
        const sx = cx + (outerRadius + 10) * cos;
        const sy = cy + (outerRadius + 10) * sin;
        const mx = cx + (outerRadius + 30) * cos;
        const my = cy + (outerRadius + 30) * sin;
        const ex = mx + (cos >= 0 ? 1 : -1) * 22;
        const ey = my;

        return (
            <g>
                <text
                    x={cx}
                    y={cy}
                    dy={8}
                    textAnchor="middle"
                    fill={fill}>
                    {payload.name} {value}
                </text>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius * 1.05}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
            </g>
        );
    };

    const getColor = (colorTheams) => {
        let theamColors = getTheamColors(colorTheams)
        setColors(theamColors)
    }
    const {
        getTheamColors
    } = useColors()
    useEffect(() => {
        getColor(colorTheams)
    }, [colorTheams])
    return (
        <ResponsiveContainer width={'100%'} height={'100%'} >
            <PieChart>
                {showLegend &&
                    <Legend
                        align="right"
                        verticalAlign='middle'
                        layout='vertical'
                        iconType="circle"
                    />}
                <Pie
                    data={data}
                    innerRadius={'60%'}
                    outerRadius={'100%'}
                    fill="#8884d8"
                    paddingAngle={1}
                    dataKey={dataKey}
                    activeIndex={activeKey}
                    activeShape={renderActiveShape}
                    onMouseEnter={onPieEnter}
                    onMouseLeave={onPieLeave}
                    labelLine={false}
                    label={renderCustomizedLabel}
                >
                    {data.map((entry, index) => {
                        return <>
                            <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                            />

                        </>

                    })}
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    )
}

export default DonutChart
